export default __webpack_public_path__ + "397b117e78fd87d1c168ae7cb685f18b.png";